import React, { useState, useEffect } from "react";
import { Container, Row, Col, Spinner } from 'react-bootstrap';
import { Skeleton, Button, Tag, Modal, Space, notification, Drawer, Image, QRCode } from 'antd';
import Common from "./includes/Common";
import Moment from 'react-moment';
import { useOutletContext } from "react-router-dom";
import { NodePlusFill, TicketPerforatedFill, GeoAltFill } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var TicketViewBracelet = function TicketViewBracelet(_ref) {
  var ticket = _ref.ticket;
  var getContrastColor = function getContrastColor(bgColor) {
    // Convert hex color to RGB
    var r = parseInt(bgColor.substr(1, 2), 16);
    var g = parseInt(bgColor.substr(3, 2), 16);
    var b = parseInt(bgColor.substr(5, 2), 16);

    // Calculate brightness using YIQ formula 
    var brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 128 ? 'black' : 'white'; // Choose best contrast
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 12,
          md: 12,
          children: /*#__PURE__*/_jsx("div", {
            style: {
              minHeight: '40px'
            },
            children: /*#__PURE__*/_jsxs(Space.Compact, {
              className: "ticket-box",
              style: {
                background: ticket.price_schema_item.color
              },
              children: [/*#__PURE__*/_jsxs(Row, {
                style: {
                  padding: "5px"
                },
                children: [/*#__PURE__*/_jsx(Col, {
                  lg: 3,
                  md: 3,
                  sm: 3,
                  xs: 3,
                  children: ticket.event && /*#__PURE__*/_jsx(Image, {
                    preview: false,
                    src: Common.baseUrl + ticket.event.image_file,
                    style: {
                      width: "100%",
                      borderRadius: "8px"
                    }
                  })
                }), /*#__PURE__*/_jsxs(Col, {
                  lg: 9,
                  md: 9,
                  sm: 9,
                  xs: 9,
                  children: [/*#__PURE__*/_jsxs(Row, {
                    children: [/*#__PURE__*/_jsx(Col, {
                      lg: 4,
                      md: 4,
                      sm: 5,
                      xs: 5,
                      children: /*#__PURE__*/_jsx(Tag, {
                        style: {
                          marginBottom: "8px"
                        },
                        color: "#EB9800",
                        children: /*#__PURE__*/_jsxs("b", {
                          children: [ticket.price_schema_item.label, "-", ticket.price_schema_item.price.toLocaleString('Fr'), " GNF"]
                        })
                      })
                    }), /*#__PURE__*/_jsx(Col, {
                      lg: {
                        span: 4,
                        offset: 4
                      },
                      md: {
                        span: 4,
                        offset: 4
                      },
                      sm: {
                        span: 4,
                        offset: 3
                      },
                      xs: {
                        span: 5,
                        offset: 2
                      },
                      children: /*#__PURE__*/_jsx(Image, {
                        width: "80px",
                        preview: false,
                        src: "/drawables/nl1_rm.png"
                      })
                    })]
                  }), /*#__PURE__*/_jsx(Row, {
                    children: /*#__PURE__*/_jsx(Col, {
                      children: /*#__PURE__*/_jsx(Space, {
                        direction: "vertical",
                        children: /*#__PURE__*/_jsx("h6", {
                          style: {
                            color: getContrastColor(ticket.price_schema_item.color)
                          },
                          children: /*#__PURE__*/_jsx("b", {
                            children: ticket.event.label
                          })
                        })
                      })
                    })
                  })]
                })]
              }), /*#__PURE__*/_jsx("div", {
                style: {
                  background: "#F3F1EE",
                  borderRadius: "4px",
                  padding: "8px 4px 4px 4px"
                },
                children: /*#__PURE__*/_jsx(QRCode, {
                  size: 80,
                  value: ticket.id.toString()
                })
              })]
            })
          })
        })
      })
    })
  });
};
export default TicketViewBracelet;